const MULTIFORMS = {
  listMultiForms: "Multiforms",
  newMultiForms: "New",

  activity: "Activity",
  group: "Group",
  totalQestion: "Total Questions:",
  company: "Company",
  quantity: "Quantity",
  state: "Status",
  actions: "Actions",

  accept: "Acept",
  cancel: "Cancel",

  NOTIFYCATIONS: {
    emptyMultiforms: `There are no registered multiforms`,
    titleGetMultiForms: "List of Forms"
  },

  CONFIRM: {
    tittleDeleteMultiForm: "Remove MultiForm: {activity}",
    textDeleteMultiForm: "This option cannot be undone, are you sure?",
    ErrorDeleteMultiFormTittle: "Delete MultiForm",
    ErrorDeleteMultiFormText: "An error occurred, deleting the MultiForm"
  },

  information: "INFORMATION",
  assiciateForms: "Associated forms:",

  mulstiStandar: "Standard forms",
  placeHolderSearch: "Search...",
  FormsAdd: "Added Forms:",
  save: "Save",
  NameToMultiForms: "Name for the multiform",

  ALERTS: {
    tittleListForms: "List of Forms",
    textAddFormToMulti: "Add forms to the list",
    nameToForm: "Form Name",
    EnterNameToForm: "Enter the name of the form",
    titleSelectedGroup: "Group Selection",
    selectedGroup: "Select the group"
  },

  success: "Created!",
  successMultiForm: "MultiForm created.",

  error: "Error!",
  errorMultiForm: "An error occurred when creating the multiform",

};

export default { MULTIFORMS };
